import { fromJS } from 'immutable';
import * as actionTypes from '../../constants/daySheetActionTypes';

const initialState = fromJS({
  list: [],
  isLoading: false,
});

export function daySheetMemberTypeTotalReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_DS_MEMBER_TYPE_TOTAL: {
      return state.set('list', fromJS(action.payload));
    }
    case actionTypes.GET_DS_MEMBER_TYPE_TOTAL_LOADING: {
      return state.set('isLoading', action.payload);
    }
    case actionTypes.CLEAR_DS_MEMBER_TYPE_TOTAL: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}

export default daySheetMemberTypeTotalReducer;
